/*eslint array-callback-return: "off"*/
import { Box, Typography } from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core";
import palette from "../../theme/palette";
import { styled } from "@mui/material/styles";
import shape from "../../theme/shape";
import { UserTypeContext } from "../../context/userStatus";
import { influenceService } from "../../services/influence";

const RootStyle = styled("div")(({ theme }) => ({
  padding: "0 0 60px 0",
  [theme.breakpoints.down("lg")]: {
    padding: "0 0 50px 0",
  },
  [theme.breakpoints.down("md")]: {
    padding: "0 0 40px 0",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "0 0 20px 0",
    marginBottom: "20px",
  },
}));

const useStyles = makeStyles((theme) => ({
  recommText: {
    backgroundColor: palette.common.white,
    borderRadius: shape.borderRadius,
    fontSize: "16px",
    lineHeight: "36px",
    color: palette.primary.light,
    padding: "12px 16px",
    cursor: "pointer",
    marginBottom: "12px",
    wordBreak: "break-word",
    [theme.breakpoints.down("sm")]: {
      padding: "10px",
      lineHeight: "20px",
    },
  },
  infoWarning: {
    fontSize: "12px",
    lineHeight: "12px",
    fontWeight: 400,
    color: "#9BA19D",
    textAlign: "center",
    marginTop: "8px",
  },
  recommTitle: {
    marginBottom: "46px",
    [theme.breakpoints.down("md")]: {
      marginBottom: "36px",
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: "20px",
    },
  },
}));

interface RecommendedListModal {
  setInfluenceData: (influenceData: string) => void;
  setInfluenceIdeas: (influenceIdeas: any) => void;
}

const RecommendedList = (props: RecommendedListModal) => {
  const classes = useStyles();
  const [influenceSuggestionList, setInfluenceSuggestionList] = useState([]);
  const { state: outcomeState } = useContext(UserTypeContext);
  useEffect(() => {
    // GET INFLUENCE SUGGESTION
    influenceService
      .getInfluenceSuggestion(outcomeState.token)
      .then((res: any) => {
        setInfluenceSuggestionList(res?.data);
        props.setInfluenceIdeas(res?.ideas);
      })
      .catch((error: any) => {
        console.log("influence suggestion error", error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RootStyle>
      <Box display="flex" alignItems="center" className={classes.recommTitle}>
        <Typography variant="h3" component="h3">
          Get started with our recommended influences
        </Typography>
      </Box>
      <Box>
        {influenceSuggestionList.length > 0 &&
          influenceSuggestionList?.map((items: any, index: number) => {
            let flag = true;
            if (outcomeState?.influenceList?.length > 0)
              for (let outObj of outcomeState?.influenceList) {
                if (outObj.name.toLowerCase() === items.name.toLowerCase()) {
                  flag = false;
                  break;
                }
              }
            if (flag) {
              return (
                <div
                  key={index}
                  className={classes.recommText}
                  onClick={() => props.setInfluenceData(items)}
                >
                  {items.name}
                </div>
              );
            }
          })}
      </Box>
      <p className={classes.infoWarning}>
        *You can add more influences after the 30 days of baseline tracking
      </p>
    </RootStyle>
  );
};
export default RecommendedList;
